import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useUserStore } from '../../../utils/userStore';
import { RouterConstant } from '../../../routers/index';

interface CatalogGridProps {
  variant?: 'off-topic' | 'select-context';
  introText?: string;
}

export const CatalogGrid: React.FC<CatalogGridProps> = ({ variant = 'select-context', introText }) => {
  const { t } = useTranslation();
  const { userInfo } = useUserStore();

  const genderAttr = userInfo?.attributes?.find((a: any) => a.att_name === 'gender')?.att_value;
  const isFemale = genderAttr === '2' || genderAttr === 'female';

  const finalIntroText = introText !== undefined
    ? introText
    : (variant === 'off-topic'
        ? `${t('v2Catalog_off_topic_intro')}`
        : (isFemale ? t('v2Catalog_fallback_intro_female') : t('v2Catalog_fallback_intro_male')));

  return (
    <div className="agent-nav-catalog" dir="rtl">
      <div className="agent-catalog-intro">
        {finalIntroText}
      </div>
      <div className="agent-catalog-section">
        <div className="agent-section-title">{t('v2Catalog_title')}</div>
        <div className="agent-links-grid">
          <Link to={RouterConstant.ROUTERS_PATH.SEARCH_LESSON} className="agent-nav-card">
            <span className="agent-card-icon study-icon"></span>
            <span className="agent-card-label">{t('v2Catalog_study')}</span>
          </Link>
          <Link to={RouterConstant.ROUTERS_PATH.SEARCHEXRCISE} className="agent-nav-card">
            <span className="agent-card-icon exercise-icon"></span>
            <span className="agent-card-label">{t('v2Catalog_exercise')}</span>
          </Link>
          <Link to={RouterConstant.ROUTERS_PATH.EXERCISES_HOMEWORK} className="agent-nav-card">
            <span className="agent-card-icon homework-icon"></span>
            <span className="agent-card-label">{t('v2Catalog_homework')}</span>
          </Link>
          <Link to={RouterConstant.ROUTERS_PATH.SELFTESTSTART} className="agent-nav-card">
            <span className="agent-card-icon exam-icon"></span>
            <span className="agent-card-label">{t('v2Catalog_exam')}</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CatalogGrid;
